import React from 'react';
import Typography from '@mui/material/Typography';

const NISTColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Control Identifier</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          Control (or Control Enhancement) Name
        </Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Control Text</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Discussion</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Related Controls</Typography>
      </div>
    </>
  );
};

export default NISTColumns;
